import { QuerySnapshot } from '@firebase/firestore-types';
import { Businesses } from '@just-in-types';
import { firestore } from '../firebase';

export default async (
  ignoredIds: string[] = ['TuNj9xLoEpFEpus1Od68', '4CxslGQeifOFbLticRuI'],
) => {
  const chesapeakeSnapshot = await firestore
    .collection(`businesses/TuNj9xLoEpFEpus1Od68/sites`)
    .doc('3X9eSU2EUxS7EzB5ydSV')
    .get();
  const chesapeakeData = chesapeakeSnapshot.data() as Businesses.Site;
  const { routes } = chesapeakeData;

  const businessesQuery = await firestore.collection('businesses').get();
  const siteQueries: Array<Promise<QuerySnapshot>> = [];

  businessesQuery.forEach(businessDoc => {
    if (ignoredIds.indexOf(businessDoc.id) === -1) {
      siteQueries.push(businessDoc.ref.collection('sites').get());
    }
  });

  const siteSnapshots = await Promise.all(siteQueries);
  const siteResults: Array<Promise<void>> = [];

  siteSnapshots.forEach(siteSnapshot => {
    siteSnapshot.forEach(siteDoc =>
      siteResults.push(
        siteDoc.ref.set(
          {
            routes: {
              ...routes,
              signature: { ...routes.signature, waiverText: 'placeholder' },
            },
            showCoupons: true,
          },
          { merge: true },
        ),
      ),
    );
  });

  await Promise.all(siteResults);

  return `${siteResults.length} routes copied!`;
};



// WEBPACK FOOTER //
// ./src/adminFunctions/copyFossRoutesToAll.ts